__turbopack_context__.v({
  "product-card": "DmhGrG_product-card",
  "product-card__separator": "DmhGrG_product-card__separator",
  "product-card__separator--bottom": "DmhGrG_product-card__separator--bottom",
});
